import {
  getPlanCategory,
  returnCalculatedGross,
  returnCalculatedTax,
  returnV2CalculatedTax,
} from '@smarty-nx/code-utils'

export const buildBoltonData = (bolton, type) => {
  if (bolton) {
    return {
      product: {
        id: bolton?.id,
        name: bolton?.name,
        category: `${type.toLowerCase()}-addon`,
        value: {
          // taken from the orderAttributes code in componentAttributes.ts
          displayGross: returnCalculatedGross(bolton?.price),
          displayTax: returnCalculatedTax(bolton?.price),
        },
      },
    }
  }
  return null
}

/**
 * Builds product data based on V2 API
 */
export const buildProductsArray = (plan, previousPlan = null) => {
  if (plan) {
    return {
      products: [
        {
          id: plan?.slug,
          name: plan?.slug,
          category: getPlanCategory(plan),
          variant: getPlanCategory(plan),
          previousPlan: previousPlan?.slug || plan?.slug,
          value: {
            // taken from the orderAttributes code in componentAttributes.ts
            displayGross: plan?.finalPriceWithoutCredit?.value,
            displayTax: returnV2CalculatedTax(
              plan?.finalPriceWithoutCredit?.value
            ),
          },
          ...buildOffer(plan),
        },
      ],
    }
  }
  return null
}

/**
 * Builds voucher data based on V2 API
 */
const buildOffer = (plan) => {
  if (plan.voucher) {
    return {
      offer: {
        lines: [
          {
            value: buildOfferValue(plan.voucher),
            data: buildOfferData(plan.voucher),
            code: plan?.voucher?.code,
          },
        ],
      },
    }
  }
  return null
}

/**
 * Builds offer data values if it exists
 */
const buildOfferData = (voucher) => {
  if (voucher?.data_amount) {
    return voucher.data_amount
  }
  return null
}

/**
 * Builds offer discount values if they exist
 */
const buildOfferValue = (voucher) => {
  if (voucher.promoDiscount) {
    return {
      displayGross: voucher?.promoDiscount?.value,
      displayTax: returnV2CalculatedTax(voucher?.promoDiscount?.value),
    }
  }
  return null
}
